var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup263(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274,
    height: 274,
    viewBox: "0 0 274 274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7258 -3273)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 274,
    transform: "translate(7258 3273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1V273H273V1H1M0,0H274V274H0Z",
    transform: "translate(7258 3273)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7271.006 3356.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.006 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4,117.978A21.984,21.984,0,1,1,75.388,95.994,21.984,21.984,0,0,1,53.4,117.978Zm0-40.022A18.038,18.038,0,1,0,71.442,95.994,18.038,18.038,0,0,0,53.4,77.956Z",
    transform: "translate(-5.369 -12.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.919,117.978a21.984,21.984,0,1,1,22.009-21.984,21.984,21.984,0,0,1-22.009,21.984Zm0-40.022a18.038,18.038,0,1,0,18.038,18.038,18.038,18.038,0,0,0-18.038-18.038Z",
    transform: "translate(-36.079 -12.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.431,89.851c-6.831,0-20.724-.448-24.04-3.971a3.432,3.432,0,0,1-.986-2.719c0-.091,0-1.119-.066-2.7-.34-13.5-.6-29.428.075-32.818l.116-.572.4-.414C6.8,40.545,28.415,37.345,56.053,33.805c10.776-1.384,20.119-2.578,23.849-3.772,6.681-2.147,14.7-7.56,22.456-12.791,8.77-5.927,17.847-12.045,25.7-13.993,20.483-5.065,46.106-4.145,65.28,2.346,8.223,2.794,32.752,21.942,36.018,24.512,6.93,1.832,15.236,4.617,16.4,7.66,1.741,4.543,4.319,43.4.829,46.993-4.211,4.286-29.842,4.708-30.116,4.708V85.524c7.809,0,24.728-1.476,27.181-3.424,1.575-3.938.373-37.875-1.558-42.915-.788-1.069-7.27-3.581-14.092-5.363l-.406-.108-.323-.249c-9.367-7.4-28.773-21.959-35.164-24.123-18.5-6.275-43.255-7.162-63.067-2.255-7.17,1.774-15.949,7.693-24.438,13.429C96.614,25.9,88.357,31.476,81.137,33.78c-4.07,1.31-13.106,2.487-24.545,3.938C38.131,40.08,10.518,43.62,4.2,48.992c-.547,4.775-.058,24.637.075,31.417.05,1.956.058,2.628.058,2.9,1.658,1.658,12.758,2.86,24.156,2.595l.091,3.954C27.926,89.826,26.824,89.851,25.431,89.851Z",
    transform: "translate(0.006 -0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109.753,
    height: 3.946,
    transform: "translate(67.523 85.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.284,35.138H110.35l4.145-3.49a191.856,191.856,0,0,1,19.547-14.092c10.577-6.632,25.507-10.246,42.02-10.246,20.467,0,38.961,5.67,48.187,14.8l.555.547ZM121.433,31.184h99.756l-.265-6.723c-8.729-8.115-25.8-13.131-44.855-13.131-15.551,0-30.108,3.523-39.931,9.657A178.909,178.909,0,0,0,121.433,31.184Z",
    transform: "translate(-18.87 -1.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.877,
    height: 3.946,
    transform: "matrix(0.3, -0.954, 0.954, 0.3, 152.841, 31.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.373,64.936c-.1-.05-9.79-4.849-17.234-4.849a8.049,8.049,0,0,1-5.894-3.1,5.2,5.2,0,0,1-1.393-4.211l.323-1.575h24.247v3.979h-19.48a3.639,3.639,0,0,0,2.205.986c8.389,0,18.569,5.057,19,5.264Z",
    transform: "translate(-45.461 -8.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.019,78.13,1.56,74.441c.158-.066,12.99-5.14,20.094-8.414-4.344-.315-12.078,1.194-18.776,3.465L1.61,65.77c5.023-1.708,21.785-6.822,26.278-1.069l1.393,1.782-1.956,1.144C22.649,70.363,3.815,77.815,3.019,78.13Z",
    transform: "translate(-0.262 -10.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.355,
    height: 3.946,
    transform: "translate(123.743 42.937)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup263);
export default __webpack_public_path__ + "static/media/Group263.4ea2f37857bc99a2ba7d0494ced19548.svg";
export { ForwardRef as ReactComponent };